export const style = {
    board: {
        bgColor: 'grey',
    },
    box: {
        bgColor: '#000',
        borderColor: "#000",
        borderLineWidth: 6,
    },
    user: {
        bgColor: '#000',
        dorRadius: 20,
    },
    bullet: {
        bgColor: '#cd0000',
        bgColorCrashed: '#fa2727',
        radius: 5,
    }
}